import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory,useLocation } from "react-router-dom";
import * as api from "../../api/index";
import { EditContext } from "../../Context/EditContext";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
// import { toCommas } from "../../utils/utils";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { getClientsByUser, getAllClients } from "../../actions/clientActions";
import { Container } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AddClient from "../Invoice/AddClient";
import {
  createMeeting,
  getMeeting,
  updateMeeting,
} from "../../actions/meetingActions";

const useStyles = makeStyles((theme) => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    backgroundColor: "#ef7f1a", // Replace 'primary.main' with your desired blue color
    color: "#fff", // White text color
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
}));

const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});
const MeetingForm = ({ onClose}) => {
  const classes = useStyles();
  const [client, setClient] = useState(null);
  const [touched, setTouched] = useState(false);
  const { currId, setCurrId } = useContext(EditContext);
  const location=useLocation();
  const user = JSON.parse(localStorage.getItem("profile"));
  const dispatch = useDispatch();
  const history = useHistory();

  const clients = useSelector((state) => state.clients.clients);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result.id || user?.result?.googleId })
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);
  //(clients);
  // const { meeting } = useSelector((state) => state.meetings);
  const [advance, setAdvance] = useState({
    cash: "",
    cheque: "",
  });
  const initialDueSummary = {
    invoiceCount: 0,
    outstandingDue: 0,
    receivableDue: 0,
    payableDue: 0,
    netBalance: 0,
    totalOutstanding: 0,
    status: "Cleared",
  };
  const [dueSummary, setDueSummary] = useState(initialDueSummary);
  const [loadingDueSummary, setLoadingDueSummary] = useState(false);
  const meeting = useSelector((state) =>
    currId ? state.meetings.meetings.find((c) => c.id === currId) : null
  );
  // //(meeting);

  const [formData, setFormData] = useState({
    remarks: "",
    payment: "",
    date: new Date(),
    paymentMode: "Cash",
    transactionType:"Payment"
  });
  const initialFormData = {
    remarks: "",
    payment: "",
    date: new Date(),
    paymentMode: "Cash",
    transactionType:"Payment"
    // Add other form fields and their initial values here
  };
  const [errors, setErrors] = useState({
    remarks: "",
    payment: "",
    client: "",
    paymentMode: "",
    transactionType:"",
  });

  // const handleFieldChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };
  const handleFieldChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setErrors((prevErrors) => {
      const nextErrors = { ...prevErrors, [name]: "" };

      if (name === "payment") {
        nextErrors.payment = validateAmount(value);
      }

      if (name === "transactionType") {
        nextErrors.payment = validateAmount(formData.payment);
      }

      return nextErrors;
    });
  };

  const toCommas = (value) => {
    return Number(value || 0).toLocaleString();
  };

  const validateAmount = (value) => {
    const amount = Number(value);

    if (!value || Number.isNaN(amount) || amount <= 0) {
      return "Amount must be greater than 0.";
    }

    const dueLimit = Number(dueSummary.outstandingDue || 0);

    if (dueLimit > 0 && amount > dueLimit) {
      return `Amount cannot be more than ${toCommas(dueLimit)}.`;
    }

    return "";
  };

  const formatCurrency = (value) => `฿${toCommas(Math.abs(Number(value || 0)))}`;

  const netBalanceDirection = (value) => {
    const amount = Number(value || 0);
    if (amount > 0) return "Agent owes ASN";
    if (amount < 0) return "ASN owes Agent";
    return "";
  };

  // const handleTime = (time) => {
  //   //(time);
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     time: time,
  //   }));
  // };
  const handleDate = (date) => {
    //();
    const formattedDate = date.toISOString().split("T")[0];
    setFormData((prevFormData) => ({
      ...prevFormData,
      date: formattedDate,
    }));
  };
  const handleClientChange = () => {
    setTouched(true);
    setErrors((prevErrors) => ({
      ...prevErrors,
      client: "",
    }));
  };

  useEffect(() => {
    let isActive = true;
  
    const loadOutstandingDue = async () => {
      const clientId = client?._id || client?.id;
  
      if (!client?.agentCode && !clientId) {
        setDueSummary(initialDueSummary);
        setLoadingDueSummary(false);
        return;
      }
  
      try {
        setLoadingDueSummary(true);
        const { data } = await api.fetchOutstandingDueByAgent({
          agentCode: client?.agentCode,
          clientId,
        });
  
        if (!isActive) return;
  
        setDueSummary({
          invoiceCount: Number(data?.invoiceCount || 0),
          outstandingDue: Number(
            data?.outstandingDue ?? data?.totalOutstanding ?? 0
          ),
          receivableDue: Number(data?.receivableDue || 0),
          payableDue: Number(data?.payableDue || 0),
          netBalance: Number(data?.netBalance || 0),
          totalOutstanding: Number(data?.totalOutstanding || 0),
          status: data?.status || "Cleared",
        });
      } catch (error) {
        if (!isActive) return;
  
        setDueSummary(initialDueSummary);
        console.error("Failed to load outstanding due amount:", error);
      } finally {
        if (isActive) setLoadingDueSummary(false);
      }
    };
  
    loadOutstandingDue();
  
    return () => {
      isActive = false;
    };
  }, [client]);

  const handleCancel = () => {
    setFormData({
      remarks: "",
      payment: "",
      date: new Date(),
      paymentMode: "Cash",
      transactionType:"Payment"
    });
    setClient(null);
    setDueSummary(initialDueSummary);
    onClose();
    setCurrId(null);
  };
  useEffect(() => {
    if (meeting) {
      setFormData(meeting);
      setClient(meeting.client);
      // setAdvance(meeting.advance);
    }
  }, [meeting]);

  
 
  useEffect(() => {
    // Add a "beforeunload" event listener to prompt the user before leaving the page
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleBeforeUnload = (event) => {
    // Check if the form has unsaved changes and display a confirmation message
    if (isFormDirty()) {
      event.preventDefault();
      event.returnValue =
        "You have unsaved changes. Are you sure you want to leave?";
    }
  };
  useEffect(() => {
    const unblock = history.block((location, action) => {
      // Check if the form has unsaved changes
      if (isFormDirty()) {
        // Prompt the user for confirmation when navigating to a different route
        return "You have unsaved changes. Are you sure you want to leave?";
      }
    });

    return () => {
      unblock(); // Unregister the route change listener when the component unmounts
    };
  }, [history]);
  const isFormDirty = () => {
    // Compare the current formData with the initialFormData
    return (
      formData.remarks !== initialFormData.remarks ||
      formData.payment !== initialFormData.payment ||
      formData.date !== initialFormData.date ||
      formData.paymentMode !== initialFormData.paymentMode||
      formData.transactionType !== initialFormData.transactionType
      // Add more fields to check as needed
      // For example, if you have additional fields in your form, include them here
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const requiredFields = ["date", "paymentMode", "payment",];
    const fieldErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        fieldErrors[field] = "This field is required.";
      }
    });

    const amountError = validateAmount(formData.payment);
    if (amountError) {
      fieldErrors.payment = amountError;
    }
    // //("Client", client);
    if (!client ||client===null) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        client: "Agent/Hotel name is required.",
      }));
      return;
    }


    setErrors(fieldErrors);

    // If there are any errors, stop the form submission
    if (Object.keys(fieldErrors).length > 0) {
      return;
    }
    if (currId) {
      dispatch(
        updateMeeting(currId, {
          ...formData,
          client,
        
        })
      );
      // history.push(`/meeting/${meeting.id}`);
    } else {
      //("in create New");
      console.log("Form Data", formData);
      //("Advances", advance);

      dispatch(
        createMeeting({
          ...formData,
          client,
          creator: [user?.result?.id || user?.result?.googleId],
          createdAt: formData.date,
          // history
        })
      );
    }
    setFormData({
      remarks: "",
      payment: "",
      date: new Date(),
      paymentMode: "Cash",
      transactionType: "Payment",
    });
    setClient(null);
    setDueSummary(initialDueSummary);
    setCurrId(null);
    onClose();
  };
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => `${option.name}|${option.agentCode}`,
  };
  const [open, setOpen] = useState(false);


  return (
    <>
      <AddClient setOpen={setOpen} open={open} />

      <Dialog
        open
        PaperProps={{ style: { minWidth: 480, maxWidth: "40vw" } }}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCancel();
          }
        }}
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialogTitle}
        >
          {currId ? "Edit Payment/Receipt" : "Add Payment/Receipt"}
          {onClose ? (
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleCancel}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>

          <form onSubmit={handleSubmit}>
            <ThemeProvider theme={colorTheme}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={6}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      label="Date"
                      name="date"
                      value={formData.date}
                      onChange={handleDate}
                      required
                      fullWidth
                      format="dd/MM/yyyy"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Container style={{ paddingLeft: 0 }}>
                    <Typography
                      variant="overline"
                      style={{ color: "gray", paddingRight: "3px" }}
                      gutterBottom
                    >
                      Selected Agent
                    </Typography>

                    {client ? (
                      <div
                        style={{
                          border: "1px solid #eee",
                          borderRadius: 10,
                          padding: 12,
                          background: "#fffaf4",
                        }}
                      >
                        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                          {client.name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {client.agentCode}
                          {client.phone ? ` - ${client.phone}` : ""}
                        </Typography>
                        {loadingDueSummary ? (
                          <div
                            style={{
                              marginTop: 10,
                              paddingTop: 8,
                              borderTop: "1px dashed #eadfce",
                              display: "flex",
                              justifyContent: "center",
                              padding: "12px 0",
                            }}
                          >
                            <CircularProgress size={20} style={{ color: "#ef7f1a" }} />
                          </div>
                        ) : (
                        <div
                          style={{
                            marginTop: 10,
                            paddingTop: 8,
                            borderTop: "1px dashed #eadfce",
                            display: "grid",
                            gridTemplateColumns: "auto 1fr",
                            columnGap: 12,
                            rowGap: 4,
                          }}
                        >
                          {[
                            // ["Agent Owes ASN", formatCurrency(dueSummary.receivableDue)],
                            // ["ASN Owes Agent", formatCurrency(dueSummary.payableDue)],
                            [
                              "Net Balance",
                              formatCurrency(dueSummary.netBalance),
                              netBalanceDirection(dueSummary.netBalance),
                            ],
                            // ["Total Outstanding", formatCurrency(dueSummary.totalOutstanding)],
                          ].map(([label, value, direction]) => (
                            <React.Fragment key={label}>
                              <Typography variant="body2" color="textSecondary">
                                {label}
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{
                                  color: "#ef7f1a",
                                  fontWeight: 600,
                                  textAlign: "right",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {value}
                              </Typography>
                              {!!direction && (
                                <>
                                  <span />
                                  <Typography
                                    variant="caption"
                                    style={{
                                      color: "#ef7f1a",
                                      textAlign: "right",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {direction}
                                  </Typography>
                                </>
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                        )}
                        <div style={{ marginTop: 10 }}>
                          <Button
                            color="primary"
                            size="small"
                            style={{
                              textTransform: "none",
                              backgroundColor: "#ef7f1a",
                              color: "white",
                              marginRight: 8,
                            }}
                            onClick={() => setClient(null)}
                          >
                            Change Agent
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <Autocomplete
                          {...clientsProps}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Agent/Hotel"
                              margin="normal"
                              variant="outlined"
                              error={touched && !!errors.client}
                              helperText={touched && errors.client}
                            />
                          )}
                          value={client}
                          onChange={(event, value) => {
                            setClient(value);
                            handleClientChange();
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              payment: "",
                            }));
                          }}
                        />
                        <Grid item style={{ paddingBottom: "10px", marginTop: 8 }}>
                          <Chip
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor: "#ef7f1a",
                                  color: "white",
                                }}
                              >
                                +
                              </Avatar>
                            }
                            label="New Agent/Hotel"
                            onClick={() => setOpen(true)}
                            variant="outlined"
                          />
                        </Grid>
                      </>
                    )}
                  </Container>
                </Grid>
                <Grid item style={{ width: "100%" }}>
                  
                </Grid>
                <Grid item xs={12}>
                  <FormLabel labelplacement="start">Payment Mode</FormLabel>
                  <RadioGroup
                    name="paymentMode"
                    value={formData.paymentMode}
                    onChange={handleFieldChange}
                    row
                  >
                    <FormControlLabel
                      value="Cash"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Cash"
                    />
                    <FormControlLabel
                      value="Online"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Online"
                    />
                    <FormControlLabel
                      value="Card"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Card"
                    />
                  </RadioGroup>
                  {!!errors.paymentMode && (
                    <Typography variant="body2" color="error">
                      {errors.paymentMode}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <FormLabel labelplacement="start">Transaction Type</FormLabel>
                  <RadioGroup
                    name="transactionType"
                    value={formData.transactionType}
                    onChange={handleFieldChange}
                    row
                  >
                    <FormControlLabel
                      value="Receipt"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Payment"
                    />
                    <FormControlLabel
                      
                      value="Payment"
                      control={<Radio style={{ color: "#ef7f1a" }} />}
                      label="Receipt"
                    />
                  </RadioGroup>
                  {!!errors.transactionType && ( // Display error message conditionally
                    <Typography variant="body2" color="error">
                      {errors.transactionType}
                    </Typography>
                  )}
                </Grid>

                <>
                <Grid item xs={12}>
                  <TextField
                    label="Amount"
                    name="payment"
                    type="number"
                    value={formData.payment}
                    onChange={handleFieldChange}
                    inputProps={{ min: 0, step: "0.01" }}
                    fullWidth
                    className={classes.formField}
                    variant="outlined"
                    size="small"
                    error={!!errors.payment} // Set error prop based on error existence
                    helperText={
                      errors.payment ||
                      "Enter amount based on outstanding due"
                    } // Display error message
                  />
                </Grid>
                </>

                <Grid item xs={12}>
                  <TextField
                    label="Remarks"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleFieldChange}
             
                    fullWidth
                    multiline
                    maxRows={4}
                    className={classes.formField}
                    variant="outlined"
                    size="small"
                    error={!!errors.remarks} // Set error prop based on error existence
                    helperText={errors.remarks} // Display error message
                  />
                </Grid>
              </Grid>
            </ThemeProvider>
          </form>
        </DialogContent>
        <DialogActions style={{ display: "flex" }}>
          <Button
            type="submit"
            variant="contained"
            // color="primary"
            style={{ backgroundColor: "#ef7f1a", color: "white" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MeetingForm;
